// utils/localizedContent.js
import { useTranslation } from 'react-i18next';

function normalizeDynamicLanguage(lang) {
    if (!lang) return lang;

    // Frontend i18next uses "zh" for Simplified Chinese,
    // while backend DeepL translations use "zh-Hans".
    if (lang === 'zh' || lang.startsWith('zh-Hans') || lang.startsWith('zh-CN')) {
        return 'zh-Hans';
    }

    if (lang.startsWith('zh-Hant') || lang.startsWith('zh-TW')) {
        return 'zh-Hant';
    }

    return lang.split('-')[0];
}

export function getLocalizedField(entity, field, lang) {
    if (!entity) return '';

    const normalizedLang = normalizeDynamicLanguage(lang);

    if (!normalizedLang) {
        return entity[field];
    }

    return entity.translations?.[normalizedLang]?.[field] ?? entity[field];
}

export function useLocalizedContent(entity, field) {
    const { i18n } = useTranslation();

    return getLocalizedField(entity, field, i18n.language);
}